import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import { alpha, Avatar, Box, Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

import { MobileBody, MobileCaption } from '../Typography';

const UserInfo: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <Grid container spacing={2} alignItems="center" wrap="nowrap">
      <Grid item>
        <Avatar
          sx={{
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.2),
          }}
        >
          <SentimentVerySatisfiedIcon sx={{ color: 'primary.main' }} />
        </Avatar>
      </Grid>
      <Grid item xs>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <MobileBody>{user?.name ?? '—'}</MobileBody>
          <MobileCaption>{user?.companyName ?? '—'}</MobileCaption>
        </Box>
      </Grid>
    </Grid>
  );
};

export default UserInfo;
